export default "__VITE_ASSET__b9462dd7__"